import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import 'rc-datepicker/lib/style.css';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import Modal_Frame from "../../biztran_controls/Modal_Frame";
import Moment from "moment";
import Session from "react-session-api";
import UseFetchData from "../../../hooks/UseFetchData";
import BiztranControls from "../../biztran_controls/BiztranControls";
import Data_Grid from "../../biztran_controls/DataGrid";
import AddExpenseSheet from "../../ExpenseSheet/AddExpenseSheet";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';



const ExpenseClaimedReport = () => {

    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [isOpen, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [columns, setColumns] = useState([]);
    const [Count, setCount] = useState();
    const [Employee, setEmployee] = useState('');
    const [Manager, setManager] = useState('');
    const [TravelLocation, setTravelLocation] = useState('');
    const [Status, setStatus] = useState('');
    const [ExpenseID, setExpenseID] = useState('');
    const [response, fetchData] = UseFetchData();


    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const openModal = (row) => {
        debugger;
        setTravelRequestID(row.id);
        setOpen(true);
    };

    const handleOpenModal = () => {
        setExpenseID('');
        setOpen(true);
    };

    const Statuscmb = [

        { id: "TR Approved", title: "TR Approved" },
        { id: "TR Rejected", title: "TR Rejected" },
        { id: "Travelling", title: "Travelling" },
        { id: "Exp Approved", title: "Exp Approved" },
        { id: "Exp Rejected", title: "Exp Rejected" },
        { id: "ACC Approved", title: "ACC Approved" },
        { id: "ACC Paid", title: "ACC Paid" },
        { id: "CFO Approved", title: "CFO Approved" },
        { id: "CFO Rejected", title: "CFO Rejected" },

    ];

    // const PopulateData = () => {
    //     var bodyFormData = new FormData();
    //     bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    //     bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    //     bodyFormData.append("EmpName", Employee);
    //     bodyFormData.append("Manager", Manager);
    //     bodyFormData.append("ApprovalStatus", Status);
    //     fetchData("/", bodyFormData);
    // }


    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['TravelRequestNo', 'TravelRequestDate', 'EmpCode', 'EmpName', 'Locationto']
                }} />
            </GridToolbarContainer>
        );
    }

    const PopulateData = () => {
        debugger;
        //Status = "ACC Approved"
        var bodyFormData = new FormData();
        if (FromDate !== "" || FromDate !== null) {
            bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        }
        else {
            bodyFormData.append("FromDate", "");
        }
        if (ToDate !== "" || ToDate !== null) {
            bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        }
        else {
            bodyFormData.append("ToDate", "");
        }
        if (Employee !== "" || Employee !== null) {
            bodyFormData.append("EmpName", Employee);
        }
        else {
            bodyFormData.append("EmpName", "");
        }
        if (Manager !== "" || Manager !== null) {
            bodyFormData.append("Manager", Manager);
        }
        else {
            bodyFormData.append("Manager", "");
        }

        if (Status !== "" && Status !== null) {
            bodyFormData.append("Status", Status);
        }
        else {
            bodyFormData.append("Status", "");
        }
        if (TravelLocation !== "" || TravelLocation !== null) {
            bodyFormData.append("TravelLocation", TravelLocation);
        }
        else {
            bodyFormData.append("TravelLocation", "");
        }

        fetchData("Reports/TravelReport", bodyFormData);
    }

    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: "Select",
                //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "TravelRequestNo",
                headerName: "TR Number",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "TravelRequestDate",
                headerName: "TR Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 190,
            },

            {
                field: "EmpCode",
                headerName: "Emp Code",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "EmpName",
                headerName: "Emp Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 190,
            },
            {
                field: "ApprovalStatus",
                headerName: "Status",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "Locationto",
                headerName: "Location To",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "ApprovedBy",
                headerName: "Approved By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "ApprovedOn",
                headerName: "Approved On",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "MngrApprovedOn",
                headerName: "CFO Approved On",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
            },

            {
                field: "ApprovalStamp",
                headerName: "Stamp",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "ExpSheetDate",
                headerName: "Expense Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "ExpSheetA",
                headerName: "Exp Sheet Approval",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "AccountsApprovedOn",
                headerName: "Accounts Approved On",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 230,
            },
            {
                field: "AccountsApprovedBy",
                headerName: "Accounts Approval",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },


        ];

        setColumns(gridCols);
        if (response.Main !== undefined) {
            debugger;
            setRows(response.Main);
            setCount(response.Main.length);
        }
    }, [response]
    );


    useEffect(() => {
        PopulateData();
        //setStatus("ACC Approved")
    }, [])

    return (
        <div>
            <Paper elevation={0}>
                <Grid container="row">
                    <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
                        <div style={{ width: "198px", marginLeft: 10, marginTop: -3 }}>
                            <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                            <DatePickerInput
                                onChange={(jsDate, dateString) => setFromDate(dateString)}
                                locale="en"
                                displayFormat="DD/MMM/YYYY"
                                className='my-react-component'
                                onClear={() => { onFromClear(); }}
                                showOnInputClick
                                maxDate={new Date()}
                                returnFormat="YYYY/MM/DD"
                                defaultValue={defaultfromDate}
                            >
                            </DatePickerInput>
                        </div>

                    </Grid>
                    <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
                        <div style={{ width: "198px", marginLeft: 9, marginTop: -3 }}>
                            <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                            <DatePickerInput
                                onChange={(jsDate, dateString) => setToDate(dateString)}
                                locale="en"
                                displayFormat="DD/MMM/YYYY"
                                className='my-react-component'
                                onClear={() => { onToClear(); }}
                                showOnInputClick
                                maxDate={new Date()}
                                returnFormat="YYYY/MM/DD"
                                defaultValue={defaultToDate}
                            >

                            </DatePickerInput>
                        </div>

                    </Grid>
                </Grid>
                <br />

                <Grid container="row" marginTop={1} >
                    <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
                        <div style={{ width: "100%", marginLeft: 2, marginTop: 1 }} >
                            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                                <BiztranControls.Input
                                    label="Employee"
                                    id="Employee"
                                    onChange={(e) => setEmployee(e.target.value)}
                                />
                            </div>
                        </div>
                    </Grid>
                    <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
                        <div style={{ width: "100%", marginLeft: 0.5, marginTop: 1 }} >
                            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                                <BiztranControls.Input
                                    label="Manager"
                                    id="Manager"
                                    onChange={(e) => setManager(e.target.value)}
                                />
                            </div>
                        </div>
                    </Grid>
                    <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: 20 }}>
                        <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
                    </div>
                </Grid>

                <Grid container direction="row" marginTop={10} style={{ paddingTop: 4 }}>
                    <Grid xs={12} md={5} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
                        <div style={{ width: "110%", marginLeft: 3, marginTop: 2 }} >
                            <div style={{ float: "left", marginTop: 0, width: "40%" }}>
                                <BiztranControls.Input
                                    label="Travel Location"
                                    id="TravelLocation"

                                    onChange={(e) => setTravelLocation(e.target.value)}
                                />
                            </div>
                        </div>
                    </Grid>
                    <Grid xs={12} md={2} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
                        <div style={{ width: "110%", marginLeft: 2, marginTop: 2 }} >
                            <div style={{ float: "left", marginTop: 0, width: "40%" }}>
                                <BiztranControls.Select
                                    label="Status"
                                    id="Status"
                                    options={Statuscmb}
                                    onChange={(e) => setStatus(e.target.value)}
                                />
                            </div></div>
                    </Grid>
                    <Grid xs={6} md={4} sm={8} lg={4} xl={3} style={{ marginTop: 15 }} >
                        <div style={{ width: "100%", marginLeft: 10, marginTop: 2 }} >
                            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                                <BiztranControls.Button
                                    text="SEARCH"
                                    startIcon={<SearchIcon />}
                                    style={{ marginTop: '10%' }}
                                    onClick={() => {
                                        PopulateData();
                                    }}
                                />
                            </div>
                            {/* <div style={{ float: "left", marginTop: 0, paddingLeft: 5, width: "30%" }}>
                                <BiztranControls.Button
                                    text="ADD NEW"
                                    startIcon={<AddCircleOutlineIcon />}
                                    style={{ marginTop: '10%' }}
                                    onClick={() => {
                                        handleOpenModal();
                                    }}
                                />
                            </div> */}

                        </div>
                    </Grid>
                </Grid>

                <Modal_Frame
                    title="User Details"
                    maxWidth="md"
                    isOpen={isOpen}
                    setOpen={setOpen}
                >
                    <AddExpenseSheet
                        TravelRequestID={TravelRequestID}
                        setOpen={setOpen}
                        PopulateData={PopulateData}
                    // pagename={"ExpenseClaim"}
                    // Status={Status}
                    />
                </Modal_Frame>

                <BiztranControls.DataGrid
                    rowHeight={25}
                    headerHeight={34}
                    rows={rows}
                    columns={columns}
                    checkboxSelection={false}
                    // autoHeight={true}
                    Width="107%"
                    Height="400px"
                    //hideFooter={true}
                    components={{ Toolbar: CustomToolbar, }}
                />
            </Paper>
        </div>
    )
}

export default ExpenseClaimedReport;